import { ErrorOutline } from '../../svgs';
import * as Styled from './ErrorContent.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorContent = ({
  id,
  errorContent
}) => /*#__PURE__*/_jsxs(Styled.ErrorContentContainer, {
  id: id,
  role: "alert",
  children: [/*#__PURE__*/_jsx(ErrorOutline, {
    width: "16",
    height: "16",
    "aria-hidden": "true"
  }), errorContent]
});